// extracted by mini-css-extract-plugin
module.exports = {"label":"index_label__1hKy6","icon":"index_icon__10tct","adsorptionSelect":"index_adsorptionSelect__kAQJA"};